"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _onChange = _ref.onChange;
  return React.createElement("input", {
    type: "checkbox",
    className: className,
    style: style,
    ref: function ref(input) {
      /* istanbul ignore else */
      if (input) {
        input.checked = checked;
        input.indeterminate = indeterminate;
        input.disabled = disabled;
      }
    },
    onChange: function onChange(e) {
      /* istanbul ignore else */
      if (_onChange) {
        _onChange(e);
      }
    }
  });
};

exports.default = Checkbox;